var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppSelect',_vm._b({attrs:{"options":_vm.product.variants,"value":_vm.val},on:{"input":function($event){return _vm.$emit('input', $event)}}},'AppSelect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }